export default __webpack_public_path__ + "media/images/react_icons/success_circle_outline-67f943b9e1b0b8a5fab8009ccd66ae73.svg";